export default __webpack_public_path__ + "static/media/body-3.e65eda07.jpg";